import './SocialMediaSection.scss';
import { FormattedMessage } from 'react-intl';
import MediumIcon from '../assets/images/medium-brands.svg'
import GithubIcon from '../assets/images/github-brands.svg'
import LinkedinIcon from '../assets/images/linkedin-brands.svg'
import { messages } from '../en-NZ';


export const SocialMediaSection = () => {

  const {
    LINKEDIN,
    MEDIUM,
    GITHUB,
    LINKEDIN_LINK,
    MEDIUM_LINK,
    GITHUB_LINK,
  } = messages;

  const socialLinks = {
    [MEDIUM]: { url: MEDIUM_LINK, icon: MediumIcon },
    [GITHUB]: { url: GITHUB_LINK, icon: GithubIcon },
    [LINKEDIN]: { url: LINKEDIN_LINK, icon: LinkedinIcon },
  };

  return (
      <div className='social-media-section'>
        { Object.keys(socialLinks).map(link => (
          <a
            className='social-media-section__link-container'
            href={ socialLinks[link].url }
            referrerPolicy="no-referrer"
            target="_blank"
            rel="noreferrer"
          >
            <img className='social-media-section__icon' src={ socialLinks[link].icon } alt={ `${link} icon` } />
            <FormattedMessage id={ link } />
          </a>
        )) }
      </div>
  );
};